export const getFirstCharacter = (name: string) => {
  return name?.charAt(0)?.toUpperCase();
};
